import { message } from 'aui';
import copy from 'copy-to-clipboard';

type TCopyToOptions = {
  errorMsg: string;
  successMsg: string;
};

export function copyTo(
  text: string,
  options: TCopyToOptions,
) {
  if (!text) {
    return;
  }

  let result = copy(text);

  if (result) {
    if (options && options.successMsg) {
      message.success(options.successMsg);
    }
  } else if (options && options.errorMsg) {
    message.error(options.errorMsg);
  }
}
